import classnames from 'classnames'
import { ComponentChild, Component } from 'preact'
import LazyLoader from '../lazy-loading/LazyLoader'

interface Props {
  idx: number
  title: string
  customClass?: string
  style?: Object
  metadata?: ComponentChild
  navigation?: {
    url: string
    target?: '_blank'
  }
  imageSrc?: string
}

class Card extends Component<Props> {
  render() {
    const { customClass, style, navigation, title, imageSrc, metadata, idx } = this.props
    return (
      <article className={classnames(customClass, 'card', 'card-widget-wrapper')} style={style}>
        {navigation && (
          <a href={navigation.url} class='card_url' target={navigation?.target}>
            {imageSrc && (
              <figure>
                <LazyLoader
                  type='background'
                  src={imageSrc}
                  classNames='card_image'
                  alt={`Community category image ${idx + 1}`}
                />
              </figure>
            )}
            <div className='card_info'>
              <header>
                <h3 className='card_info__title card-widget-title'>{title}</h3>
              </header>
              {Boolean(metadata) && <p className='text--meta card-info__metadata'>{metadata}</p>}
            </div>
          </a>
        )}
      </article>
    )
  }
}

export default Card
